document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('header');

    if(!header) {
        return;
    }

    let isScrolled = false;
    
    function handleScroll() {
        const currentScroll = window.pageYOffset;
        
        if (!isScrolled && currentScroll > 50) {
            header.classList.add('scrolled');
            isScrolled = true;
        } else if (isScrolled && currentScroll <= 20) {
            header.classList.remove('scrolled');
            isScrolled = false;
        }
    }
    
    handleScroll();
    
    window.addEventListener('scroll', handleScroll);
});

